





































































































import { Component, Vue, Inject} from 'vue-property-decorator'
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import QuickTable from "../../../../components/table/table.vue";
import Tools from '../../../../lib/tools';
import SelectDep from "../../../../components/select/selectDep.vue";
@Component({
	name:'secretManage',
	components: {
		QuickTable,
		SelectDep
	}
})
export default class SecretManage extends AbpBase  {
    initData:any = {
    	showModal: false,		// 弹窗显示状态
    	formLoading: false,		// 表单提交状态
    	showBackModal: false,
    	backFormLoading: false,
    	organizations: [],		// 部门数据
    	personnels: [],
    	searchData: {
    		Name: ''
    	},
    	formData: {
    		datumName: '',
    		borrowUserId: '',
    		borrowUserDepId: '',
    		borrowMedia: '',
    		borrowDt: '',
    		usedBackOrDelete: 'true'
    	},
    	addValidate: {
    		datumName: [
	            { required: true, message: '请输入资料名称', trigger: 'blur' }
	        ],
	        borrowUserId: [
	            { required: true, type: 'number', message: '请选择借取人', trigger: 'change' }
	        ],
	        borrowUserDepId: [
	            { required: true, type: 'number', message: '请选择借取人所属部门', trigger: 'change' }
	        ],
	        borrowMedia: [
	            { required: true, message: '请输入借取介质', trigger: 'blur' }
	        ],
	        borrowDt: [
	            { required: true, type: 'date', message: '请选择归还或删除时间', trigger: 'change' }
	        ]
    	},
    	backForm: {
    		id: '',
    		datumName: '',
    		usedBackOrDelete: 'true',
    		returnUserId: '',
    		returnDt: ''
    	},
    	backValidate: {
    		returnUserId: [
	            { required: true, type: 'number', message: '请输入规划人或删除监督人', trigger: 'change' }
	        ],
	        returnDt: [
	            { required: true, type: 'date', message: '请选择归还或删除时间', trigger: 'change' }
	        ]
    	},
    	datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
    	columns: [
            {
            	title: '序号',
                type: 'index',
                width: 62,
                align: 'center'
            },
            {
                title: '借阅人',
                key: 'borrowUser',
                render: (h:any, params:any) => {
                	return h('span', params.row.borrowUser ? params.row.borrowUser.name : '');
                }
            },
            {
                title: '资料名称',
                key: 'datumName'
            },
            {
                title: '借取介质',
                key: 'borrowMedia'
            },
            {
                title: '借取时间',
                key: 'borrowDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.borrowDt));
				}
            },
            {
                title: '使用后归还或删除',
                key: 'usedBackOrDelete',
                render: (h:any, params:any) => {
                	return h('span', params.row.usedBackOrDelete ? '归还' : '删除');
                }
            },
            {
                title: '归还人或删除监督人',
                key: 'returnUser',
                render: (h:any, params:any) => {
                	return h('span', params.row.returnUser ? params.row.returnUser.name : '');
                }
            },
            {
                title: '归还或删除时间',
                key: 'returnDt',
                render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.returnDt));
				}
            },
            {
                title: '操作',
                width: 188,
                render: (h:any, params:any) => {
                	//if(params.row.returnUserId) return h('span', '无');
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                			},
							on: {
								click: () => {
    								this.initData.backForm.id = params.row.id;
    								this.initData.backForm.datumName = params.row.datumName;
    								this.initData.backForm.usedBackOrDelete = params.row.usedBackOrDelete.toString();
    								this.initData.backForm.returnUserId = params.row.returnUserId;
    								this.initData.backForm.returnDt = params.row.returnDt;
									this.initData.showBackModal = true;
								}
							}
                		}, '归还或删除登记'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
        ]
    }
    GetData() {
        (this as any).$refs.table.GetData();
    }
    // 新增
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {
            		datumName: this.initData.formData.datumName,
		    		borrowUserId: this.initData.formData.borrowUserId,
		    		borrowUserDepId: this.initData.formData.borrowUserDepId,
		    		borrowMedia: this.initData.formData.borrowMedia,
		    		borrowDt: Tools.formatDate(this.initData.formData.borrowDt),
		    		usedBackOrDelete: (this.initData.formData.usedBackOrDelete == 'true' ? true : false)
            	}
    			this.initData.formLoading = true;
                await Ajax.post('/api/services/app/SafetyProduct/CreateSecretAsync', params).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    // 归还或删除
    async handleSubmitBack() {
    	(this.$refs.backForm as any).validate(async (valid:boolean)=>{
            if(valid){
            	let params:any = {
            		id: this.initData.backForm.id,
		    		usedBackOrDelete: (this.initData.backForm.usedBackOrDelete == 'true' ? true : false),
		    		returnUserId: this.initData.backForm.returnUserId,
		    		returnDt: Tools.formatDate(this.initData.backForm.returnDt)
            	}
    			this.initData.backFormLoading = true;
                await Ajax.post('/api/services/app/SafetyProduct/SecretReturnOrDeleteAsync', params).then((res:any)=>{
	                this.$Message.success('登记成功!');
	                this.initData.backFormLoading = false;
	                this.initData.showBackModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.initData.backFormLoading = false;
	            })
            }
        })
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此制度？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteSecretAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		(this as any).$refs.form.resetFields();
    	}
    }
    handleClearBackForm(flog:any) {
    	if(!flog) {
    		this.initData.showBackModal = false;
    		(this as any).$refs.backForm.resetFields();
    	}
    }
    // 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personnels = this.$store.state.project.allPersons;
    	})
    }
    mounted() {
    	this.init();
    }
}
